import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Navigation from '../Navigation';
// Default
import LandingPage from '../Landing';
// Authentication
import SignUpPage from '../Authentication/SignUp';
import SignInPage from '../Authentication/SignIn';
import PasswordForgetPage from '../Authentication/PasswordForget';
// Account Management
import AccountPage from '../Account';
import AdminPage from '../Admin';
// The Actual Exhibit
import ExhibitPage from '../Exhibit';

import * as ROUTES from '../../constants/routes';
import { withAuthentication } from '../Session';
import { SignUpSuccess } from '../Authentication/SignUp';

const App = () => (
  <Router>
    <div>
      <Navigation />
      <Route exact path={ROUTES.LANDING} component={LandingPage} />
      <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
      <Route path={ROUTES.SIGN_UP_SUCCESS} component={SignUpSuccess} />
      <Route path={ROUTES.SIGN_IN} component={SignInPage} />
      <Route path={ROUTES.EXHIBIT} component={ExhibitPage} />
      <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage} />
      <Route path={ROUTES.ACCOUNT} component={AccountPage} />
      <Route path={ROUTES.ADMIN} component={AdminPage} />
    </div>
  </Router>
);

export default withAuthentication(App);
